import { useControllableState } from '@rn-primitives/hooks';
import { CheckmarkIcon } from '../../Icons/CheckmarkIcon';
import { cn } from '../../lib/utils';
import { SwitchProps } from './Switch.types';

export const Switch = ({
  onCheckedChange,
  className,
  checked,
  defaultChecked,
}: SwitchProps) => {
  const [internalChecked, handleCheckedChange] = useControllableState({
    prop: checked,
    onChange: onCheckedChange,
    defaultProp: defaultChecked,
  });

  return (
    <button
      className={cn(
        'flex flex-row items-center pl-0.5 transition-colors duration-200 group w-16 h-8 bg-neutral-500 rounded-[22px]',
        internalChecked && 'bg-primary',
        className,
      )}
      onClick={() => handleCheckedChange(!internalChecked)}
    >
      {internalChecked && <CheckmarkIcon className="ml-2" />}
      <div
        className={cn(
          'shadow-lg w-7 h-7 rounded-full bg-white duration-200 absolute',
          internalChecked && 'translate-x-8',
        )}
      />
    </button>
  );
};
